<!-- export-addresses-dialog.component.html -->
<div class="flex flex-col h-full max-h-[90vh]">
  <!-- Header (Fixed) -->
  <div class="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b">
    <h2 class="text-lg font-bold">{{ modalTitle }}</h2>
    <button mat-icon-button (click)="onCancel()" class="ml-auto -mr-2">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content (Scrollable) -->
  <div class="flex-1 overflow-y-auto min-h-0 p-6">
    <!-- Export Type Selection -->
    <div class="mb-6">
      <label class="block text-lg font-semibold mb-4">
        Tipo de Exportación
      </label>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Empty Template Card -->
        <div
          (click)="onExportTypeChange('empty')"
          class="relative flex flex-col p-6 rounded-2xl border-2 cursor-pointer transition-all duration-200 hover:shadow-lg"
          [class.border-primary]="exportType === 'empty'"
          [class.bg-primary-50]="exportType === 'empty'"
          [class.border-gray-200]="exportType !== 'empty'"
          [class.bg-white]="exportType !== 'empty'">
          
          <div class="flex items-start gap-4">
            <div 
              class="flex items-center justify-center w-12 h-12 rounded-xl"
              [class.bg-primary]="exportType === 'empty'"
              [class.bg-gray-100]="exportType !== 'empty'">
              <mat-icon 
                class="icon-size-7"
                [class.text-white]="exportType === 'empty'"
                [class.text-gray-500]="exportType !== 'empty'"
                [svgIcon]="'heroicons_outline:document'">
              </mat-icon>
            </div>
            
            <div class="flex-1">
              <div class="flex items-center gap-2 mb-2">
                <h3 
                  class="text-lg font-semibold"
                  [class.text-primary]="exportType === 'empty'">
                  Plantilla Vacía
                </h3>
                <mat-icon 
                  *ngIf="exportType === 'empty'"
                  class="icon-size-5 text-primary"
                  [svgIcon]="'heroicons_solid:check-circle'">
                </mat-icon>
              </div>
              <p class="text-sm text-gray-600">
                Descarga una plantilla excel vacía con las columnas necesarias para asignar o remover territorios de direcciones.
              </p>
            </div>
          </div>
        </div>

        <!-- Filled Template Card -->
        <div
          (click)="onExportTypeChange('filled')"
          class="relative flex flex-col p-6 rounded-2xl border-2 cursor-pointer transition-all duration-200 hover:shadow-lg"
          [class.border-primary]="exportType === 'filled'"
          [class.bg-primary-50]="exportType === 'filled'"
          [class.border-gray-200]="exportType !== 'filled'"
          [class.bg-white]="exportType !== 'filled'">
          
          <div class="flex items-start gap-4">
            <div 
              class="flex items-center justify-center w-12 h-12 rounded-xl"
              [class.bg-primary]="exportType === 'filled'"
              [class.bg-gray-100]="exportType !== 'filled'">
              <mat-icon 
                class="icon-size-7"
                [class.text-white]="exportType === 'filled'"
                [class.text-gray-500]="exportType !== 'filled'"
                [svgIcon]="'heroicons_outline:document-text'">
              </mat-icon>
            </div>
            
            <div class="flex-1">
              <div class="flex items-center gap-2 mb-2">
                <h3 
                  class="text-lg font-semibold"
                  [class.text-primary]="exportType === 'filled'">
                  Plantilla con Datos
                </h3>
                <mat-icon 
                  *ngIf="exportType === 'filled'"
                  class="icon-size-5 text-primary"
                  [svgIcon]="'heroicons_solid:check-circle'">
                </mat-icon>
              </div>
              <p class="text-sm text-gray-600">
                Exporta direcciones existentes aplicando filtros personalizados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters Section (Only shown when 'filled' is selected) -->
    <div 
      *ngIf="exportType === 'filled'"
      class="animate-fade-in-up">
      
      <!-- Alert Info -->
      <fuse-alert
        class="mb-6"
        [appearance]="'border'"
        [type]="'info'">
        <span fuseAlertTitle>Filtros de Exportación</span>
        Configura los filtros para exportar solo las direcciones que necesitas. Los filtros son opcionales.
      </fuse-alert>

      <!-- Filters Container with Form Sections -->
      <div class="space-y-4" [formGroup]="form">
        
        <!-- Business Partners Section -->
        <app-form-section 
          title="Socios de Negocio" 
          icon="business" 
          iconColor="blue">
          <app-business-partners-filters 
            [form]="form" 
            [businessGroupList]="businessGroupList"
            [businessPartnerTypeList]="businessPartnerTypeList" 
            [businessPartner]="true"
            [loadData]="loadFiltersData">
          </app-business-partners-filters>
        </app-form-section>

        <!-- Routes Section -->
        <app-form-section 
          title="Rutas y Territorios" 
          icon="map" 
          iconColor="green">
          <app-routes-filters 
            [form]="form"
            [territory]="true" 
            [loadData]="loadFiltersData">
          </app-routes-filters>
        </app-form-section>

        <!-- Action Section -->
        <app-form-section 
          title="Acción a Realizar" 
          icon="settings" 
          iconColor="purple">
          <div class="grid grid-cols-1 gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Seleccionar acción</mat-label>
              <mat-select formControlName="action" class="uppercase">
                <mat-option class="uppercase" value="Asignación única">
                  Asignación única
                </mat-option>
                <mat-option class="uppercase" value="Extender asignación">
                  Extender asignación
                </mat-option>
                <mat-option class="uppercase" value="Remover de todo">
                  Remover de todo
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </app-form-section>
      
      </div>
    </div>
  </div>

  <!-- Footer Actions (Fixed) -->
  <mat-dialog-actions class="flex-shrink-0 flex justify-end gap-2 p-4 border-t bg-white">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="onExport()" [disabled]="isLoading">
      <span>{{ isLoading ? 'Exportando...' : 'Exportar' }}</span>
    </button>
  </mat-dialog-actions>
</div>